module.exports = __webpack_public_path__ + "static/media/pharmacy_supplier.c6922c00.png";